<template>
  <div class="home">
     <App-navigation></App-navigation>
     <Category></Category>
  </div>
</template>

<script>
// @ is an alias to /src
import AppNavigation from '@/components/Navigation/AppNavigation.vue'
import Category from '@/components/Category/Category.vue'
export default {
  name: 'home',
  components: {
    AppNavigation,
    Category
  }
}
</script>
